import { render, staticRenderFns } from "./CategoryLegend.vue?vue&type=template&id=9ef18618&scoped=true&"
import script from "./CategoryLegend.vue?vue&type=script&lang=ts&"
export * from "./CategoryLegend.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryLegend.vue?vue&type=style&index=0&id=9ef18618&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef18618",
  null
  
)

export default component.exports